import {Page} from '../core/pagination/page';
import {Activiteit, VerwerkingsStatus} from './activiteit';
import {Client} from '../client/client';
import User from '../core/auth/user';

export class ActiviteitPage extends Page<Activiteit> {

  constructor(
    private verwerkingsStatus: VerwerkingsStatus,
    ascending: boolean,
    pageSize: number,
    pageNumber: number,
    lastPage: boolean,
    activiteiten: Array<Activiteit>,
    private clienten: Array<Client>,
    private auteurs: Array<User>,
  ) {
    super(ascending, pageSize, pageNumber, lastPage, activiteiten);
  }

  getVerwerkingsStatus(): VerwerkingsStatus {
    return this.verwerkingsStatus;
  }

  getClient(clientId: string): Client {
    return this.clienten.find(client => client.hasId(clientId));
  }

  getAuteur(auteurId: string): User {
    return this.auteurs.find(auteur => auteur.hasId(auteurId));
  }

  getPrevious(activiteit: Activiteit): Activiteit {
    const index = this.getItems().indexOf(activiteit);
    return this.getItems()[index - 1];
  }

  getNext(activiteit: Activiteit): Activiteit {
    const index = this.getItems().indexOf(activiteit);
    return this.getItems()[index + 1];
  }
}
